import type { ConnectorUsage } from "../types";

export function cohereUsage(): ConnectorUsage {
  return {
    measures: [
      { measure: "input_tokens", perModel: true },
      { measure: "output_tokens", perModel: true },
    ],
  };
}
